import React from "react";
// ANT DESIGN COMPONENTS
import { Collapse } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { faFileCode } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector } from "react-redux";
// INTERFACES
import {
	AdapterCdoModbusInterface,
	ModbusToLn2Entry,
	Ln2ToModbusEntry,
} from "../../../../../interfaces/AdapterCdoModbus.interface";
import { RootState } from "../../../../../app/store";
// COMPONENTS
import DrawerRowDivider from "../../../../components/drawer/DrawerRowDivider";
import FormInputNumber from "../../../../components/form/FormInputNumber";
import ComponentMsgToLn2 from "./ComponentMsgToLn2";
import ComponentLn2ToMsg from "./ComponentLn2ToMsg";
import ComponentUploadJson from "./ComponentUploadJson";

export default function CdoModbusPage({
	setCdo,
	cdoValue,
}: {
	setCdo: (newValue: AdapterCdoModbusInterface) => void;
	cdoValue: AdapterCdoModbusInterface;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Panel } = Collapse;
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// HELPERS **************************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// USE MEMO *************************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeInputNumber = (newValue: number, variableName: string) => {
		const copy: AdapterCdoModbusInterface = structuredClone(cdoValue);
		if (variableName === "slave_id") {
			copy.slave_id = newValue;
		}
		setCdo(copy);
	};

	const onChangePollingInterval = (newValue: number) => {
		const copy: AdapterCdoModbusInterface = structuredClone(cdoValue);
		copy.polling_interval = newValue;
		setCdo(copy);
	};

	const setMsgToLn2Map = (newValue: ModbusToLn2Entry[]) => {
		const copy: AdapterCdoModbusInterface = structuredClone(cdoValue);
		copy.msg_to_ln2_map = newValue;
		setCdo(copy);
	};

	const setLn2ToMsgMap = (newValue: Ln2ToModbusEntry[]) => {
		const copy: AdapterCdoModbusInterface = structuredClone(cdoValue);
		copy.ln2_to_msg_map = newValue;
		setCdo(copy);
	};

	const renderJsonWithColors = (obj: any) => {
		const json = JSON.stringify(obj, null, 4);

		return json.split("\n").map((line, index) => {
			const keyMatch = line.match(/"([^"]+)"\s*:/);
			const numberMatch = line.match(/:\s*(\d+)/);
			const stringMatch = line.match(/:\s*"([^"]*)"/);

			return (
				<div key={index}>
					{keyMatch ? (
						<>
							<span style={{ color: "#9cdcfe" }}>{`"${keyMatch[1]}"`}</span>:
							{stringMatch && (
								<span
									style={{ color: "#ce9178" }}
								>{`" ${stringMatch[1]} "`}</span>
							)}
							{numberMatch && (
								<span style={{ color: "#b5cea8" }}>{numberMatch[1]}</span>
							)}
						</>
					) : (
						line
					)}
				</div>
			);
		});
	};

	// ************************************************ */
	// USE CALLBACK *********************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<DrawerRowDivider icon={faFileCode} title='MODBUS' />
			<Collapse>
				<Panel header={`JSON ${t("general.preview")}`} key='1'>
					<div className='container'>
						<div className={`drawer__box__${theme} row`}>
							<pre
								style={{
									width: "100%",
									color: "#dcdcdc",
									padding: "10px",
									borderRadius: "8px",
									overflowX: "auto",
								}}
							>
								{renderJsonWithColors(cdoValue)}
							</pre>
						</div>
					</div>
				</Panel>
			</Collapse>
			<br />
			<Collapse>
				<Panel header={`${t("general.formulary")}`} key='2'>
					<div className='container'>
						<div className={`drawer__box__${theme} row`}>
							<FormInputNumber
								inputValue={cdoValue.slave_id}
								inputLabelName='Slave ID'
								inputOnChange={onChangeInputNumber}
								inputVariableName='slave_id'
								
							/>
							<FormInputNumber
								inputValue={cdoValue.polling_interval}
								inputLabelName='Polling interval'
								inputOnChange={onChangePollingInterval}
								inputVariableName='polling_interval'
								
							/>
							{/* <FormInputText
								inputValue={cdoValue.polling_interval.toString()}
								inputLabelName='Polling interval'
								inputOnChange={onChangePollingInterval}
								inputVariableName='polling_interval'
								isRequired
								disabledInput={false}
								
							/> */}
							<ComponentUploadJson
								onUploadJson={(newValue) => {
									setCdo(newValue);
								}}
							/>
						</div>
					</div>
				</Panel>
			</Collapse>
			<br />
			<Collapse>
				<Panel header='Message to LN2' key='3'>
					<ComponentMsgToLn2
						msgToLn2Map={cdoValue.msg_to_ln2_map}
						setMsgToLn2Map={setMsgToLn2Map}
					/>
				</Panel>
			</Collapse>
			<br />
			<Collapse>
				<Panel header='Ln2 to Message' key='4'>
					<ComponentLn2ToMsg
						ln2ToMsgMap={cdoValue.ln2_to_msg_map}
						setLn2ToMsgMap={setLn2ToMsgMap}
					/>
				</Panel>
			</Collapse>
		</div>
	);
}
